import { TSToChartEvent } from '@thoughtspot/ts-chart-sdk';
import { sendMessage } from '../../../services/post-message-event-dispatcher';
export const triggerChartReRender = ({ iFrameWindow, appUrl, }) => {
    const payload = {
        eventType: TSToChartEvent.TriggerRenderChart,
        payload: {},
    };
    return sendMessage(iFrameWindow, payload, appUrl);
};
//# sourceMappingURL=index.js.map